// extracted by mini-css-extract-plugin
export default {"label":"TableHeader_label__rShP0","headerSpacing":"TableHeader_headerSpacing__y9yGM"};